import '@/styles/tokens.css'
import '@/styles/base.css'
import '@/styles/themes.css'
import { bootstrap } from '@/app/bootstrap'

bootstrap().catch((err) => {
  console.error('bootstrap failed', err)
  const el = document.getElementById('app')
  if (el) {
    el.innerHTML =
      '<p style="font-family: system-ui; padding: 2rem;">' +
      'Die Anwendung konnte nicht geladen werden. Bitte versuchen Sie es später erneut.' +
      '</p>'
  }
})
